
































import { Vue, Component, Emit, Ref, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import Modal from '@/components/imageTab/ImageModal.vue'
import qrCode from '@/components/common/qr/qr.vue'

@Component({
  components: {
    Modal: () => import('@/components/imageTab/ImageModal.vue'),
    qrCode: () => import('@/components/common/qr/qr.vue')
  }
})
export default class QRReader extends Vue {
  $store!: ExStore

  error = ''
  success = ''
  afterMount = false
  size = {
    width: 100,
    height: 200
  }
  total = 1
  done = [false] as boolean[]

  @Prop({ default: '' }) errorMessage!: string

  @Emit('error')
  qrError($event: string) {
    this.success = ''
    this.error = $event
    return $event
  }
  @Emit('success')
  qrSuccess($event: string) {
    this.error = ''
    this.success = $event
    return $event
  }

  modalMounted() {
    this.size.width = this.camera.clientWidth
    this.size.height = this.camera.clientHeight
    this.afterMount = true
  }

  @Ref('camera') camera!: HTMLDivElement
  @Ref('qrCode') qrCode!: qrCode
  @Ref('modal') modal!: Modal

  @Emit('close')
  onClose() {
    this.qrCode.reset()
    this.qrCode.reader.reset()
    return
  }

  @Watch('errorMessage')
  onUpdateError(err: string) {
    this.error = err
  }
}
